import { sortBy } from 'lodash-es';
import { stringify } from 'query-string';

import i18n from '../locals/i18n';
import {
  DepartmentTemplate,
  DepartmentTemplateField,
  FetchCrudData,
  FoodTrayTemplate,
  ReportField,
  Store,
  StoreField,
} from '../models';
import { ReportFilterOptions } from '../redux/reports/reducer';
import { Network } from '../utils';

export const GET_REPORTS_FIELDS: string = [
  ReportField.STORE_NAME,
  ReportField.DEPARTMENT_NAME,
  ReportField.TEMPLATE_NAME,
  ReportField.ACTION,
  ReportField.DATE,
  ReportField.ACTION_SUBJECT,
].join(',');

export const getReports = async (queryParams: FetchCrudData) => {
  return Network.get(
    `reports?${stringify({
      ...queryParams,
      fields: GET_REPORTS_FIELDS,
      s: JSON.stringify(queryParams.s),
    })}`,
  );
};

export const getFilterOptions = async (
  storeId: string | null,
  departmentTemplateId: string | null,
): Promise<ReportFilterOptions> => {
  const storeFields = [StoreField.ID, StoreField.NAME, StoreField.EXTERNAL_ID].join(',');
  const departmentTemplateFields = [DepartmentTemplateField.ID, DepartmentTemplateField.NAME].join(',');

  // TODO change endpoints so we can also fetch deleted stores and deleted departmentTemplates
  let departmentTemplatesPromise;
  if (storeId) {
    // Get only department templates linked to the selected store
    departmentTemplatesPromise = Network.get(`stores/${storeId}`);
  } else {
    // Get all department templates
    departmentTemplatesPromise = Network.get(`departmentTemplates?${stringify({ fields: departmentTemplateFields })}`);
  }
  let [storesResponse, departmentTemplatesResponse, foodTrayTemplatesResponse] = await Promise.all([
    Network.get(`stores?${stringify({ fields: storeFields })}`),
    departmentTemplatesPromise,
    departmentTemplateId
      ? Network.get(
          `foodTrayTemplates/names?${stringify({
            departmentTemplateId,
            storeId,
          })}`,
        )
      : Promise.resolve([]),
  ]);

  if (storeId) {
    departmentTemplatesResponse = (departmentTemplatesResponse as Store).departments.map(dep => dep.departmentTemplate);
  }
  const deleted = ` (${i18n.t('lblDeleted')})`;
  return {
    stores: sortBy(
      storesResponse.data.map((store: Store) => ({
        label: `${store.externalId} - ${store.name}${store.isDeleted ? deleted : ''}`,
        value: store.id,
      })),
      ['externalId'],
    ),
    departmentTemplates: sortBy(
      departmentTemplatesResponse.map((departmentTemplate: DepartmentTemplate) => ({
        label: `${departmentTemplate.name}${departmentTemplate.isDeleted ? deleted : ''}`,
        value: departmentTemplate.id,
      })),
      ['label'],
    ),
    foodTrayTemplates: sortBy(
      foodTrayTemplatesResponse.map((foodTrayTemplate: FoodTrayTemplate) => ({
        label: foodTrayTemplate.name + (foodTrayTemplate.isDeleted ? deleted : ''),
        value: foodTrayTemplate.id,
      })),
      ['name'],
    ),
  };
};
